import '../../style/index.less';
import './index.less';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../node_modules/antd/es/spin/style/index.js
// module id = 360
// module chunks = 12